var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1197L28.2439 0.454394C29.3363 -0.151465 30.6636 -0.151465 31.7559 0.454394L59.9999 16.1197H0Z",
    fill: "#00A991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7568 0.454394C30.6645 -0.151465 29.3371 -0.151465 28.2448 0.454394L27.707 0.752636L55.4133 16.1198H60.0007L31.7568 0.454394Z",
    fill: "#007F6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9986 47.5337C35.2284 47.5337 39.4679 43.2921 39.4679 38.0598C39.4679 32.8275 35.2284 28.5859 29.9986 28.5859C24.7689 28.5859 20.5293 32.8275 20.5293 38.0598C20.5293 43.2921 24.7689 47.5337 29.9986 47.5337Z",
    fill: "#FFE179"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9984 28.5859C29.3788 28.5859 28.7739 28.6473 28.1875 28.761C32.5507 29.6066 35.846 33.4473 35.846 38.0598C35.846 42.6723 32.5507 46.513 28.1875 47.3587C28.7738 47.4723 29.3788 47.5337 29.9984 47.5337C35.2282 47.5337 39.4677 43.2921 39.4677 38.0598C39.4677 32.8275 35.2282 28.5859 29.9984 28.5859Z",
    fill: "#FBD268"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 37.1539H30.9041V34.0104H31.0994C31.5034 34.0104 31.8448 34.4466 31.8448 34.9628C31.8448 35.4631 32.2502 35.8687 32.7502 35.8687C33.2502 35.8687 33.6556 35.4631 33.6556 34.9628C33.6556 33.4387 32.5088 32.1987 31.0993 32.1987H30.904V31.6977C30.904 31.1975 30.4987 30.7919 29.9986 30.7919C29.4986 30.7919 29.0932 31.1975 29.0932 31.6977V32.1987H28.8981C27.4885 32.1987 26.3418 33.4387 26.3418 34.9628V36.2016C26.3418 37.7257 27.4886 38.9657 28.8981 38.9657H29.0932V42.1091H28.8981C28.4941 42.1091 28.1526 41.673 28.1526 41.1567C28.1526 40.6565 27.7472 40.2509 27.2472 40.2509C26.7471 40.2509 26.3418 40.6565 26.3418 41.1567C26.3418 42.6809 27.4886 43.9208 28.8981 43.9208H29.0932V44.4218C29.0932 44.9221 29.4986 45.3277 29.9986 45.3277C30.4988 45.3277 30.904 44.9221 30.904 44.4218V43.9208H31.0993C32.5088 43.9208 33.6556 42.6809 33.6556 41.1567V39.918C33.6557 38.3938 32.509 37.1539 31.0993 37.1539ZM28.8981 37.154C28.4941 37.154 28.1526 36.7178 28.1526 36.2016V34.9628C28.1526 34.4466 28.4939 34.0104 28.8981 34.0104H29.0932V37.1539H28.8981V37.154ZM31.8449 41.1567C31.8449 41.673 31.5035 42.1091 31.0995 42.1091H30.9043V38.9656H31.0994C31.5035 38.9656 31.8449 39.4017 31.8449 39.918V41.1567Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 11.9887C31.8 11.9887 33.2594 10.5287 33.2594 8.72764C33.2594 6.92659 31.8 5.46655 29.9998 5.46655C28.1996 5.46655 26.7402 6.92659 26.7402 8.72764C26.7402 10.5287 28.1996 11.9887 29.9998 11.9887Z",
    fill: "#ED8535"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0004 5.46655C29.3302 5.46655 28.7074 5.66917 28.1895 6.01604C29.0629 6.60104 29.6381 7.59702 29.6381 8.72764C29.6381 9.85827 29.0629 10.8541 28.1895 11.4392C28.7074 11.7862 29.3302 11.9887 30.0004 11.9887C31.8006 11.9887 33.2599 10.5287 33.2599 8.72764C33.2599 6.92659 31.8006 5.46655 30.0004 5.46655Z",
    fill: "#BE6A2A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3786 54.5647H41.8613L45.483 49.4645H52.7568L56.3786 54.5647Z",
    fill: "#00A991"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7564 49.4645H49.1348L52.7564 54.5647H56.3782L52.7564 49.4645Z",
    fill: "#007F6D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3786 21.5548H41.8613L45.483 26.6552H52.7568L56.3786 21.5548Z",
    fill: "#00A991"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7564 21.5548L49.1348 26.6552H52.7564L56.3782 21.5548H52.7564Z",
    fill: "#007F6D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4824 26.6552H52.7562V49.4645H45.4824V26.6552Z",
    fill: "#EAF6FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1348 26.6552H52.7564V49.4645H49.1348V26.6552Z",
    fill: "#D8ECFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1403 54.5647H3.62305L7.24484 49.4645H14.5187L18.1403 54.5647Z",
    fill: "#00A991"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1403 21.5548H3.62305L7.24484 26.6552H14.5187L18.1403 21.5548Z",
    fill: "#00A991"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24414 26.6552H14.518V49.4645H7.24414V26.6552Z",
    fill: "#EAF6FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5183 49.4645H10.8965L14.5183 54.5647H18.14L14.5183 49.4645Z",
    fill: "#007F6D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5183 21.5548L10.8965 26.6552H14.5183L18.14 21.5548H14.5183Z",
    fill: "#007F6D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8965 26.6552H14.5182V49.4645H10.8965V26.6552Z",
    fill: "#D8ECFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1196H59.9999V18.8372C59.9999 20.338 58.7838 21.5548 57.2837 21.5548H2.71629C1.21617 21.5548 0 20.3381 0 18.8372L0 16.1196Z",
    fill: "#ED8535"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3784 16.1196V18.8372C56.3784 20.3381 55.1622 21.5548 53.6621 21.5548H57.2838C58.7839 21.5548 60.0001 20.3381 60.0001 18.8372V16.1196H56.3784Z",
    fill: "#BE6A2A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20726 54.5647H58.7927C59.4595 54.5647 59.9999 55.1054 59.9999 55.7725V58.7921C59.9999 59.4591 59.4595 60 58.7927 60H1.20726C0.540468 59.9998 0 59.4591 0 58.792V55.7724C0 55.1054 0.540468 54.5647 1.20726 54.5647Z",
    fill: "#ED8535"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7936 54.5647H55.1719C55.8387 54.5647 56.3791 55.1054 56.3791 55.7725V58.7921C56.3791 59.4591 55.8387 60 55.1719 60H58.7936C59.4603 60 60.0008 59.4593 60.0008 58.7921V55.7725C60.0008 55.1054 59.4603 54.5647 58.7936 54.5647Z",
    fill: "#BE6A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetBanking);
export default __webpack_public_path__ + "static/media/net-banking.16e2b587f8b6e1d7bfba02eb55d8a8f3.svg";
export { ForwardRef as ReactComponent };